import { useCallback, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export const Lightbox = ({ images, index, onClose, onNavigate }) => {
  const prev = useCallback(() => onNavigate((index - 1 + images.length) % images.length), [index, images.length, onNavigate]);
  const next = useCallback(() => onNavigate((index + 1) % images.length), [index, images.length, onNavigate]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, prev, next]);

  return (
    <AnimatePresence>
      {index !== null && (
        <motion.div
          data-testid="lightbox"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] flex items-center justify-center bg-ink/95 p-4"
          onClick={onClose}
        >
          <button data-testid="lightbox-close" onClick={onClose} aria-label="Chiudi" className="absolute right-4 top-4 rounded-full bg-sand/10 p-2.5 text-sand transition-colors hover:bg-sand/20">
            <X size={24} />
          </button>
          <button
            data-testid="lightbox-prev"
            onClick={(e) => { e.stopPropagation(); prev(); }}
            aria-label="Precedente"
            className="absolute left-3 top-1/2 -translate-y-1/2 rounded-full bg-sand/10 p-3 text-sand transition-colors hover:bg-sand/20 sm:left-6"
          >
            <ChevronLeft size={26} />
          </button>
          <motion.img
            key={images[index].src}
            src={images[index].src}
            alt={images[index].alt || ""}
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
            className="max-h-[85vh] max-w-full rounded-lg object-contain shadow-2xl"
          />
          <button
            data-testid="lightbox-next"
            onClick={(e) => { e.stopPropagation(); next(); }}
            aria-label="Successiva"
            className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full bg-sand/10 p-3 text-sand transition-colors hover:bg-sand/20 sm:right-6"
          >
            <ChevronRight size={26} />
          </button>
          <span data-testid="lightbox-counter" className="absolute bottom-5 left-1/2 -translate-x-1/2 rounded-full bg-sand/10 px-4 py-1.5 text-sm font-semibold text-sand">
            {index + 1} / {images.length}
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
